// import { NavLink } from "react-router-dom";

// export default function TopNav() {
//   const baseClass =
//     "px-4 py-2 transition duration-200 transform"; // transform added
//   const inactiveClass = "text-gray-400 hover:text-white hover:scale-110";
//   const activeClass = "text-cyan-500 font-semibold";

//   return (
//     <nav className="flex space-x-6 bg-[#2d2c2c] font-semibold text-xl px-4 py-2 rounded-bl-3xl border border-gray-600">
//       {["about", "resume", "project", "contact", "gallery"].map((item) => (
//         <NavLink
//           key={item}
//           to={`/${item}`}
//           className={({ isActive }) =>
//             `${baseClass} ${isActive ? activeClass : inactiveClass}`
//           }
//         >
//           {item.charAt(0).toUpperCase() + item.slice(1)}
//         </NavLink>
//       ))}
//     </nav>
//   );
// }

import { NavLink } from "react-router-dom";

export default function TopNav() {
  const baseClass =
    "px-2 sm:px-4 py-2 transition duration-200 transform"; // 🔥 mobile spacing smaller
  const inactiveClass = "text-gray-300 hover:text-white hover:scale-110";
  const activeClass = "text-cyan-600 font-semibold";

  return (
   
    <nav
  className="
    flex 
    bg-[#2a2727] 
    font-semibold 
    text-base sm:text-lg md:text-xl
    px-2 sm:px-4 py-2
    border border-gray-400
    w-full md:w-auto  
    justify-evenly
    rounded-t-3xl md:rounded-br-3xl   
    "
>

      {["about", "resume", "project", "contact", "gallery"].map((item) => (
        <NavLink
          key={item}
          to={`/${item}`}
          className={({ isActive }) =>
            `${baseClass} ${isActive ? activeClass : inactiveClass}`
          }
        >
          {item.charAt(0).toUpperCase() + item.slice(1)}
        </NavLink>
      ))}
    </nav>
  );
}
